'use client';

import { IcChevronRight, Typography } from '@bgzt/ui';

import { LinkByEnvironment } from '~/components';
import { PROMOTION_2025_04_KAKAO } from '~/app/_constants';

import styles from './KakoPromotionBanner.module.css';

type Props = {
  price?: number;
};
export const KakoPromotionBanner = ({ price }: Props) => {
  const renderPriceText = (_price?: number) => {
    if (!_price) return '';
    return _price >= 200_000 ? '15,000' : '7,000';
  };
  return (
    <LinkByEnvironment href={PROMOTION_2025_04_KAKAO.EXHIBITION_URL} target="_blank">
      <div className={styles.container}>
        <div className={styles.badge}>선착순</div>
        <div className={styles.content}>
          <Typography variant="L10" color="#FAE100">
            카카오페이머니 결제 시
          </Typography>
          <Typography variant="L9" color="#ffffff">
            {`${renderPriceText(price)}원 즉시 할인`}
          </Typography>
        </div>
        <IcChevronRight fill={'#ffffff'} size={10} />
      </div>
    </LinkByEnvironment>
  );
};
